module.exports = __webpack_public_path__ + "img/experience-old.4201e06e.jpg";